import {PaymentMethods} from "../enums/payment-methods";
import {ModelBase} from "../models/model-base";

export class PaymentMethodTranslation {
  static translation= {
    [PaymentMethods.Cash]: 'Bar',
    [PaymentMethods.Card]: 'Karte',
    [PaymentMethods.Employee]: 'Mitarbeiter',

  }



  static translate(paymentMethod: PaymentMethods): string {
    return this.translation[paymentMethod];
  }

  static translateValueToKey(paymentMethod: string) {
    for(let key in PaymentMethodTranslation.translation) {
      // @ts-ignore
      if(PaymentMethodTranslation.translation[key] === paymentMethod) {
        return key;
      }
    }
    return undefined
  }

  static paymentMethodToModelDict(): { [id: string]: ModelBase } {
    let paymentMethodModelDict: { [id: string]: ModelBase } = {};
    for (let key in PaymentMethodTranslation.translation) {
      let modelBase = new ModelBase();
      modelBase.id = key;
      modelBase.name = PaymentMethodTranslation.translation[key as unknown as keyof typeof PaymentMethodTranslation.translation] as string;
      paymentMethodModelDict[key] = modelBase;
    }
    return paymentMethodModelDict;
  }
}
